import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';

export class GoogleAuthCore {
  private static isInitialized = false;

  static async initialize(): Promise<void> {
    if (this.isInitialized) return;

    if (Capacitor.isNativePlatform()) {
      const nativeWebClientId = import.meta.env.VITE_GOOGLE_NATIVE_WEB_CLIENT_ID || '';
      const nativeIosClientId = import.meta.env.VITE_GOOGLE_NATIVE_IOS_CLIENT_ID || '';
      await SocialLogin.initialize({
        google: {
          webClientId: nativeWebClientId,
          iOSClientId: nativeIosClientId,
          iOSServerClientId: nativeWebClientId,
          mode: 'online'
        }
      });
    }
    
    this.isInitialized = true;
  }

  static async signIn(): Promise<string> {
    if (!Capacitor.isNativePlatform()) {
      throw new Error('GoogleAuthCore.signIn is only supported on native platforms. Use @react-oauth/google on web.');
    }

    await this.initialize();

    const result = await SocialLogin.login({
      provider: 'google',
      options: {}
    });

    if (result?.result && 'idToken' in result.result && result.result.idToken) {
      return result.result.idToken;
    }

    throw new Error('No token received from Google sign-in');
  }
}
